/* src/app/components/ups-select/ups-select.component.scss */
.form-select {
  background: #FFF;
  position: relative;
  border-color: #979797;
}
.ups-select-icon {
  display: inline-block;
}
.ups-select-icon:after {
  font-family: upsicons, fantasy !important;
  content: "\e626" !important;
  color: #02857e;
  position: absolute;
  top: 10px;
  right: 15px;
  pointer-events: none;
}
.ups-select-icon.disabled:after {
  color: #6e6e6e;
}
:host {
  position: relative;
  display: flex;
}
/*# sourceMappingURL=ups-select.component.css.map */
